module.exports = __webpack_public_path__ + "media/assets/images/events/matteo-interview-6ab05a7b2bdf3ccd77d5a0e29adb89b1.png";